import React from 'react';

import Button from '../../components/Button';

const PromotionalListItem = ({
  title,
  subtitle,
  btnText,
  href,
  onClick,
}) => (
  <div
    className={`
      PromotionalListItem
      flex
      flex-col
      md:flex-row
      md:justify-between
      py-6
      px-5
      pr-6
      my-2
      -mx-4
      md:-mx-2
      md:rounded-lg
    `}
  >
    <div className="flex flex-col">
      <span className="font-bold text-lg pb-1">{title}</span>
      <span>{subtitle}</span>
    </div>
    <div className="flex items-center whitespace-nowrap">
      <Button
        asLink={Boolean(href)}
        href={href}
        onClick={onClick}
        className={`
          PromotionalListItem__button
          p-2
          px-8
          mt-4 
          md:mt-0
          rounded
          text-white 
          font-semibold
        `}
      >
        {btnText}
      </Button>
    </div>
  </div>
);

export default PromotionalListItem;
